import React from 'react';
import {Table} from '@devexpress/dx-react-grid-material-ui';
import {useStyles} from 'util/Styles';

export const CustomNoDataCell = (props) => {
  const {noDataCell} = useStyles();

  return <Table.NoDataCell className={noDataCell} {...props} />;
};
